import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useQuickbooksStatusCheck = (): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  return useQuery([ReactQueryKeys.QuickbooksStatus], async () => {
    const response = await treasureApi().get('/quickbooks/getOauthStatus');

    return response.data;
  });
};
